import { FC } from 'react';
import { Box, Collapse, Fade, IconName, VStack } from '@wegroup/design-system';
import AnvaProductCartWidget from '@flows/src/components/flow-products/quotes/cart/AnvaProductCartWidget';
import FlowProductsSideBarOverviewItems from '@flows/src/components/flow-products/sidebar/FlowProductsSideBarOverviewItems';
import FlowProductsSideBarBasketItems from '@flows/src/components/flow-products/sidebar/FlowProductsSideBarBasketItems';

export interface FlowProductsSidebarItem {
  key: string;
  label: string;
  iconName?: IconName;
}

interface Props {
  items: FlowProductsSidebarItem[];
  isHidden?: boolean;
}

const FlowProductsSidebar: FC<Props> = ({ items, isHidden }) => {
  const isBasketPage = window.location.pathname.includes('basket');
  const width = isBasketPage
    ? 'md'
    : isHidden
    ? '0'
    : { base: '2xs', laptopL: 'xs' };
  const borderRight = isHidden ? '0' : '1px';

  return (
    <Box position="relative" maxH="100vh">
      {/* This box makes sure the content on the right side is shown with the correct marginleft */}
      <Box w={width} visibility="hidden" transition="0.5s" />
      <VStack
        w={width}
        transition="0.5s"
        align="stretch"
        overflow="hidden"
        bg="white"
        pt="9"
        pb="4"
        // px={px}
        h="100%"
        spacing="0"
        borderRight={borderRight}
        borderColor="gray.50"
        transform="auto"
        position="fixed"
        top="0"
      >
        <VStack
          flexGrow="1"
          spacing="6"
          align="stretch"
          overflow="hidden"
          opacity={isBasketPage ? 0 : 1}
          maxH={isBasketPage ? '0%' : '100%'}
          transition="0.5s"
          mb={isBasketPage ? '0' : '8'}
        >
          <FlowProductsSideBarOverviewItems items={items} />
        </VStack>
        <Collapse
          in={isBasketPage}
          animateOpacity
          unmountOnExit
          transition={{
            enter: { duration: 0.4 },
            exit: { duration: 0.2 },
          }}
        >
          <FlowProductsSideBarBasketItems />
        </Collapse>

        <Fade in={!isBasketPage} unmountOnExit>
          <AnvaProductCartWidget />
        </Fade>
      </VStack>
    </Box>
  );
};

export default FlowProductsSidebar;
